var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.391 52.5668C212.062 54.2981 212.018 56.2252 211.269 57.9242C210.52 59.6232 209.126 60.955 207.395 61.6268C129.453 91.8528 79.0899 165.385 79.0899 248.959C79.0899 260.381 80.0579 271.839 81.9659 283.015C82.138 284.02 82.0883 285.051 81.8202 286.036C81.5521 287.02 81.0722 287.934 80.414 288.713C79.7558 289.492 78.9352 290.118 78.0097 290.547C77.0842 290.977 76.0761 291.198 75.0559 291.197C73.4047 291.194 71.8073 290.609 70.5459 289.543C69.2845 288.477 68.4401 287 68.1619 285.373C66.1143 273.343 65.0854 261.162 65.0859 248.96C65.0859 204.772 78.4019 162.326 103.596 126.211C128.213 90.9208 162.355 64.0728 202.33 48.5698C204.062 47.8986 205.989 47.9426 207.688 48.6921C209.387 49.4417 210.719 50.8354 211.391 52.5668ZM456.285 126.21C431.672 90.9218 397.538 64.0738 357.575 48.5698C355.844 47.8981 353.917 47.9417 352.218 48.6909C350.518 49.4401 349.187 50.8336 348.515 52.5648C347.843 54.296 347.887 56.2231 348.636 57.9222C349.385 59.6212 350.779 60.9531 352.51 61.6248C429.237 91.3918 480.787 166.675 480.787 248.959C480.787 359.715 390.693 449.821 279.952 449.821C264.449 449.82 248.998 448.027 233.906 444.48C232.105 444.073 230.217 444.395 228.652 445.373C227.087 446.352 225.972 447.909 225.549 449.706C225.126 451.503 225.43 453.394 226.394 454.968C227.358 456.542 228.905 457.671 230.698 458.111C246.841 461.906 263.369 463.823 279.952 463.825C398.414 463.825 494.79 367.436 494.79 248.959C494.791 204.774 481.476 162.329 456.285 126.21Z",
    fill: "#C6C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.482 230.676H215.351C250.557 230.676 279.386 259.476 279.386 294.711V315.205C257.531 328.755 229.921 336.862 199.931 336.862C169.912 336.862 142.303 328.755 120.447 315.205V294.711C120.447 259.476 149.276 230.676 184.482 230.676Z",
    fill: "#00D696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.931 230.677C228.192 230.677 251.266 207.603 251.266 179.342C251.266 151.052 228.192 127.978 199.931 127.978C171.641 127.978 148.567 151.052 148.567 179.342C148.567 207.603 171.641 230.677 199.931 230.677Z",
    fill: "#FFAF93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.482 230.676H201.915C163.052 230.676 131.276 262.452 131.276 301.315V321.242C127.578 319.393 123.965 317.378 120.448 315.204V294.71C120.447 259.476 149.276 230.676 184.482 230.676Z",
    fill: "#00C78B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.931 127.978C202.085 127.978 204.211 128.12 206.309 128.375C180.939 131.521 161.323 153.121 161.323 179.342C161.323 205.534 180.939 227.134 206.309 230.281C204.193 230.542 202.063 230.674 199.931 230.678C171.556 230.678 148.567 207.689 148.567 179.343C148.567 150.967 171.556 127.978 199.931 127.978Z",
    fill: "#EE8778"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.526 230.676H375.424C410.63 230.676 439.43 259.476 439.43 294.711V315.205C417.603 328.755 389.994 336.862 359.975 336.862C329.956 336.862 302.375 328.755 280.52 315.205V294.711C280.52 259.476 309.32 230.676 344.526 230.676Z",
    fill: "#8399FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.975 230.677C388.265 230.677 411.339 207.603 411.339 179.342C411.339 151.052 388.265 127.978 359.975 127.978C331.685 127.978 308.64 151.052 308.64 179.342C308.64 207.603 331.685 230.677 359.975 230.677Z",
    fill: "#FFAF93"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.526 230.676H361.959C323.124 230.676 291.348 262.452 291.348 301.315V321.242C287.646 319.399 284.033 317.384 280.52 315.204V294.71C280.52 259.476 309.32 230.676 344.526 230.676Z",
    fill: "#728BF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.975 127.978C362.129 127.978 364.284 128.12 366.353 128.375C341.011 131.521 321.395 153.121 321.395 179.342C321.395 205.534 341.011 227.134 366.353 230.281C364.237 230.542 362.107 230.675 359.975 230.678C331.629 230.678 308.64 207.689 308.64 179.343C308.64 150.967 331.629 127.978 359.975 127.978Z",
    fill: "#EE8778"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.953 6.99414L291.802 40.5561L327.405 41.4921L299.143 63.1481L309.292 97.2781L279.953 77.0951L250.614 97.2781L260.762 63.1481L232.501 41.4921L268.076 40.5561L279.953 6.99414Z",
    fill: "#FFCA28"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.953 77.0951L250.614 97.2781L260.762 63.1481L232.501 41.4921L268.076 40.5561L279.953 6.99414V77.0951Z",
    fill: "#FBC02D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.973 260.156H296.932C335.653 260.156 367.345 291.847 367.345 330.569V353.133C343.307 368.043 312.948 376.944 279.953 376.944C246.929 376.944 216.599 368.043 192.561 353.133V330.569C192.561 291.848 224.252 260.156 262.973 260.156Z",
    fill: "#FF5BA8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.953 260.157C311.049 260.157 336.419 234.787 336.419 203.691C336.419 172.595 311.049 147.225 279.953 147.225C248.829 147.225 223.459 172.595 223.459 203.691C223.459 234.787 248.829 260.157 279.953 260.157Z",
    fill: "#FFAF93"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.973 260.156H282.135C239.417 260.156 204.466 295.107 204.466 337.825V359.765C200.405 357.724 196.433 355.511 192.56 353.132V330.568C192.561 291.848 224.252 260.156 262.973 260.156Z",
    fill: "#ED4593"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.953 147.225C282.334 147.225 284.659 147.367 286.955 147.65C259.09 151.108 237.519 174.891 237.519 203.691C237.519 232.519 259.091 256.274 286.955 259.732C284.659 260.015 282.335 260.157 279.953 260.157C248.772 260.157 223.459 234.872 223.459 203.691C223.458 172.51 248.772 147.225 279.953 147.225Z",
    fill: "#EE8778"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7969 426.216L120.586 382.366L140.156 401.908L96.3659 445.758L76.7969 426.216Z",
    fill: "#4A4D71"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.095 296.1C258.778 328.812 258.778 381.82 226.095 414.503C193.412 447.186 140.404 447.186 107.72 414.503C75.0075 381.82 75.0075 328.812 107.72 296.1C140.403 263.416 193.411 263.416 226.095 296.1Z",
    fill: "#5B5E8B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.296 497.926C33.735 507.365 49.213 507.365 58.652 497.926L98.621 457.957C101.342 455.236 101.342 450.785 98.621 448.064L74.13 423.601C72.8212 422.295 71.0472 421.561 69.1975 421.561C67.3479 421.561 65.5739 422.295 64.265 423.601L24.296 463.57C14.857 473.01 14.857 488.459 24.296 497.926Z",
    fill: "#FFCA28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.194 305C244.974 332.78 244.974 377.822 217.194 405.602C189.414 433.382 144.372 433.382 116.621 405.602C88.8411 377.823 88.8411 332.78 116.621 305C144.372 277.249 189.414 277.249 217.194 305Z",
    fill: "#4A4D71"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.625 312.597C233.209 336.181 233.209 374.421 209.625 398.005C186.012 421.618 147.773 421.618 124.189 398.005C100.605 374.421 100.605 336.181 124.189 312.597C147.774 289.013 186.013 289.013 209.625 312.597Z",
    fill: "#8BF0FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.304 426.748L74.129 423.602C72.8201 422.296 71.0461 421.562 69.1965 421.562C67.3469 421.562 65.5729 422.296 64.264 423.602L24.296 463.57C14.913 472.924 14.857 488.203 24.069 497.671C21.546 488.799 23.757 478.849 30.702 471.904L73.902 428.704C74.8517 427.774 76.0224 427.101 77.304 426.748Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/Boost.90359c94af95929a10cfabe3d5d6af9a.svg";
export { ForwardRef as ReactComponent };